/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const DataServicesEnum = {
    GET_DATA_SERVICES: '/data-services',
    GET_DATA_SERVICES_BY_NAME: (name: string): string => {
        return `/data-services/${name}`;
    },
    PUT_DATA_SERVICES_NAME: (name: string): string => {
        return `/data-services/${name}`;
    },
};
